(()=>{
  const ready=(fn)=>document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn,{once:true}):fn();
  const norm=(s)=>(s||'').replace(/\s+/g,' ').trim();
  const leafNodes=()=>Array.from(document.querySelectorAll('body *')).filter(el=>el.children.length===0&&norm(el.textContent));

  function replaceExact(from,to){
    leafNodes().forEach(el=>{ if(norm(el.textContent)===from) el.textContent=to; });
  }

  function hideClosest(el,selectors){
    if(!el)return;
    const target=el.closest(selectors);
    (target||el).classList.add('klaxon-clean-hidden');
  }

  function cleanDemoContent(){
    document.documentElement.classList.add('klaxon-furniture-store');
    replaceExact('WELCOME TO OUR STORE LOGO','KLAXON FURNITURE');
    replaceExact('24/7 help','KLAXON Support');
    replaceExact('Worldwide fashion store with wide collection of styles with over 100 international fashion brands.','Modern, space-smart furniture for study, dining, storage and everyday Indian homes.');
    replaceExact('+1-202-555-0158','Contact KLAXON');
    replaceExact('loremipsum@gmail.com','Product Support');
    replaceExact('165th St, Jamaica, NY 11','India-wide online furniture store');

    document.querySelectorAll('a[href*="shopify.pxf.io"]').forEach(a=>{
      const wrap=a.closest('[class*="announcement"],[class*="ticker"],.shopify-section,li');
      if(wrap&&/shopify|free trial|theme/i.test(norm(wrap.textContent)))wrap.classList.add('klaxon-clean-hidden');
      else a.classList.add('klaxon-clean-hidden');
    });

    document.querySelectorAll('a').forEach(a=>{
      const t=norm(a.textContent);
      if(t==='Buy Theme'||t==='Themeforest'||t==='Start free trial store')hideClosest(a,'li,[class*="featured"],[class*="menu-item"],.shopify-section');
      if(t==='Contact KLAXON'||t==='Product Support'){
        a.setAttribute('href','/pages/contact-klaxon');
        a.removeAttribute('target');
      }
    });

    ['Try Shopify store for FREE!','Save 30-70% Sitewide!!!','Real customer reviews from themeforest.net','Powered by Bigsteps'].forEach(function(phrase){
      leafNodes().forEach(el=>{ if(norm(el.textContent).includes(phrase))hideClosest(el,'[class*="announcement"],[class*="ticker"],[class*="footer"],.shopify-section,li'); });
    });

    ['[class*="newsletter-popup"]','[id*="newsletter-popup"]','[class*="popup-newsletter"]','[id*="popup-newsletter"]','[class*="promo-products"]','[id*="promo-products"]','[class*="purchase-notification"]','[id*="purchase-notification"]'].forEach(sel=>document.querySelectorAll(sel).forEach(el=>el.classList.add('klaxon-clean-hidden')));
    document.querySelectorAll('img[alt]').forEach(img=>{ if(/lumia|fashion default|themeforest/i.test(img.alt||''))img.alt='KLAXON Furniture'; });
  }

  ready(cleanDemoContent);
})();